import { render, staticRenderFns } from "./ObjectTreeNodePrimitive.vue?vue&type=template&id=cb7e4f32&"
import script from "./ObjectTreeNodePrimitive.vue?vue&type=script&lang=js&"
export * from "./ObjectTreeNodePrimitive.vue?vue&type=script&lang=js&"
import style0 from "./ObjectTreeNodePrimitive.vue?vue&type=style&index=0&id=cb7e4f32&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports